<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Cancelamento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-area
                no-margin-top
                title="Agendamentos"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-table
                            :fields="fields"
                            :items="agendamentos"
                            @filter-changed="handleAgendamentoFilterChanged"
                            @filtered="agendamentosFiltered = $event"
                        >
                            <template v-slot:head(checkbox)>
                                <rkm-form-checkbox
                                    :indeterminate="indeterminate"
                                    :value="true"
                                    @change="checkUncheckAll"
                                    v-model="checkedAll"
                                />
                            </template>

                            <template v-slot:cell(checkbox)="{item}">
                                <rkm-form-checkbox
                                    :value="true"
                                    @change="handleCheckboxChange"
                                    v-model="item.selecionado"
                                />
                            </template>

                            <template v-slot:cell(pacienteTelefones)="{ item }">
                                {{ handlePhone(item.pacienteTelefones) }}
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button @click="close">
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="quantidadeAgendamentosSelecionadas === 0"
                @click="cancel"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        quantidadeAgendamentos() {
            return this.agendamentosFiltered.length
        },
        quantidadeAgendamentosSelecionadas() {
            return this.agendamentos
                .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                .filter(agendamento => agendamento.selecionado === true).length
        },
        validations() {
            return {
                motivo: {
                    required: true,
                    max: 500,
                },
            }
        },
    },
    created() {
        this.repositories = {
            reagendamentoExame: this.getConectaSusRepository('exameImagem.reagendamentoExame'),
        }
    },
    data: () => ({
        agendamentos: [],
        agendamentosFiltered: [],
        checkedAll: false,
        fields: [
            {key: 'checkbox', label: '#', class: 'col-min text-center'},
            {key: 'horaExame', label: 'Horário'},
            {key: 'paciente.nome', label: 'Nome'},
            {key: 'paciente.dataNascimento', label: 'Data de nascimento'},
            {key: 'paciente.prontuario', label: 'Prontuário'},
            {key: 'pacienteTelefones', label: 'Telefone'},
            {key: 'usuario', label: 'Agendador'},
        ],
        indeterminate: false,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.reset()

            this.$refs.RkmModal.show()

            this.load(date)
        },
        load(date) {

            this.agendamentos = Object.assign(this.data.model.origem.agendamentos
                .filter(agendamento => agendamento.data === this.others.moment(date).format('DD/MM/YYYY')))
                .map(agendamento => ({...agendamento, selecionado: false})
            )
        },
        handleAgendamentoFilterChanged() {
            this.checkedAll = false
            this.indeterminate = false
            this.agendamentos.map(agendamento => agendamento.selecionado = false)
        },
        checkUncheckAll(value) {
            this.checkedAll = value
            this.indeterminate = false

            this.agendamentos
                .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                .map(agendamento => agendamento.selecionado = value)
        },
        handleCheckboxChange() {
            this.checkedAll = false
            this.indeterminate = false

            if (this.quantidadeAgendamentosSelecionadas > 0) {
                if (this.quantidadeAgendamentosSelecionadas === this.quantidadeAgendamentos) {
                    this.checkedAll = true
                } else  {
                    this.indeterminate = true
                }
            }
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        cancel() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const agendamentos = this.agendamentos
                        .filter(agendamento => this.agendamentosFiltered.find(agendamentoFiltered => agendamentoFiltered.id === agendamento.id))
                        .filter(agendamento => agendamento.selecionado === true)

                    const request = {
                        agendamentos: agendamentos.map(agendamento => (agendamento.id)),
                        motivo: this.data.model.cancelamento.motivo
                    }

                    this.setLoading()

                    this.repositories.reagendamentoExame.cancel(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.close()
                            this.$emit('saved', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        close() {
            this.$refs.RkmModal.hide()
        },
        reset() {
            this.agendamentos = []
            this.agendamentosFiltered = []
            this.checkedAll = false
            this.indeterminate = false
            this.data.model.cancelamento.motivo = null
        }
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
        usuarioId: {type: Number, required: true},
    },
    watch: {
        agendamentos(value) {
            this.agendamentosFiltered = value
            this.checkedAll = false
            this.indeterminate = false
        },
    },
}
</script>